export function settlementDetailOptions(
  detailRows,
  settlementRows,
  currentUid
) {
  const settledByDetail = {}
  ;(settlementRows || []).forEach((settlement) => {
    if (!settlement || String(settlement.uid) === String(currentUid || '')) {
      return
    }
    const details = settlement.details || []
    details.forEach((line) => {
      const uid = String((line && line.contractDetailUid) || '')
      if (!uid) return
      settledByDetail[uid] =
        (settledByDetail[uid] || 0) + Number((line && line.quantity) || 0)
    })
  })
  return (detailRows || []).map((item) => {
    const uid = String((item && item.uid) || '')
    return Object.assign({}, item, {
      contractQuantity: Number((item && item.quantity) || 0),
      settledQuantity: settledByDetail[uid] || 0
    })
  })
}
